import React from "react";
import {  BiUserCheck } from "react-icons/bi";
import { formatCurrency } from "../utils/utils";

const Card = ({
  className = "",
  titleClassName = "",
  valueClassName = "",
  iconClassName = "",
  icon = <BiUserCheck />,
  title = "Test",
  isCurrency = true,
  value = 1000000,
  ...props
}) => {
  return (
    <div
      className={`w-full sm:w-1/3 md:w-1/5 border-2 border-gray-200 rounded-xl h-32 p-5 flex flex-col justify-center items-end gap-5 ${className}`}
    >
      <div className="flex flex-row  items-center justify-center w-full ">
        <span
          className={`text-lg font-bold text-green-500 w-full ${titleClassName}`}
        >
          {title}
        </span>
        <span className={`text-4xl text-green-500 ${iconClassName}`}>
          {icon}
        </span>
      </div>
      <div className=" justify-center items-center w-full ">
        <div
          className={`text-2xl font-bold w-full overflow-auto ${valueClassName}`}
        >
          {isCurrency ? formatCurrency(value) : value}
        </div>
      </div>
    </div>
  );
};

export default Card;
